import {
  ISpecialistCategory,
  ISpecialistPreview
} from 'app/interfaces/specialists';
import { mapImageFields } from 'app/adapters/common';
import { IImage } from 'app/interfaces/common';

export function mapServiceCategoryFields(
  item: Directus.SpecialistCategory
): ISpecialistCategory {
  return {
    ...item
  };
}

export function mapSpecialistPreviewFields(
  item: Directus.SpecialistPreview
): ISpecialistPreview {
  return {
    ...item,
    image_preview: (item.image_preview
      ?.filter(img => !!img.file)
      ?.map(img => mapImageFields(img.file)) || []) as IImage[],
    image_work: (item.image_work
      ?.filter(img => !!img.file)
      ?.map(img => mapImageFields(img.file)) || []) as IImage[]
  };
}
